import { useMemo } from 'react';
import { useShallow } from 'zustand/shallow';

import { useChatTabsStore } from '../../store/chatTabsStore';
import { useChatInstancesStore } from '../../store/chatInstancesStore';
import { useTargetId, useTargetType } from '../../store/projectStore';

const ACTIVE_CHAT_STATUSES = new Set(['streaming', 'submitted']);

export function useActiveChatProgress() {
  const currentTargetId = useTargetId();
  const currentTargetType = useTargetType();
  const chatIds = useChatTabsStore(
    useShallow((state) =>
      state.chatTabs
        .filter((tab) =>
          currentTargetId
            ? tab.targetId === currentTargetId &&
              tab.targetType === currentTargetType
            : !tab.targetId,
        )
        .map((tab) => tab.chatId),
    ),
  );

  const activeChatIds = useChatInstancesStore(
    useShallow((state) =>
      chatIds.filter((chatId) => {
        const status = state.getChatStatus(chatId);
        return status !== null && ACTIVE_CHAT_STATUSES.has(status);
      }),
    ),
  );
  const activeChatIdSet = useMemo(
    () => new Set(activeChatIds),
    [activeChatIds],
  );

  return {
    activeChatCount: activeChatIdSet.size,
    activeChatIds: activeChatIdSet,
    hasActiveChats: activeChatIdSet.size > 0,
  };
}
